import { render, staticRenderFns } from "./ProductAlphabeticalComponent.vue?vue&type=template&id=2e4c67a8&"
import script from "./ProductAlphabeticalComponent.ts?vue&type=script&lang=ts&"
export * from "./ProductAlphabeticalComponent.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductAlphabeticalComponent.vue"
export default component.exports